module.exports = __webpack_public_path__ + "static/img/pending.c2b6ace7.png";